/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { Stack, IconButton } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import EditIcon from '@material-ui/icons/Edit';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import SearchNotFound from '../../../SearchNotFound';

export default function SpecialProductCategoryListing(props) {

    let encrypted = "";
    const navigate = useNavigate();

    const [productCategoryList, setProductCategoryList] = useState([]);

    useEffect(() => {
        trackPromise(getproductcategories());
    }, []);

    async function getproductcategories() {
        var productCategoryList = await services.GetProductCategoties()
        setProductCategoryList(productCategoryList)
    }

    function handleClick(datas) {
        encrypted = AESEncryptionParam(datas.specialProductCategoryID.toString());
        navigate('/dashboard/specialProductCategory/addedit/' + encrypted)
    }

    return (
        <>
            <LoadingComponent />
            <Page title=" Special Product Category |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/specialProductCategory/addedit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Special Product Categories"
                    />
                    <br /><Divider variant="middle" /><br />
                    {productCategoryList.length == 0 ?
                        <SearchNotFound searchQuery="Special Product Categories" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Special Category Code</TableCell>
                                                <TableCell align="center">Special Category Name</TableCell>
                                                <TableCell align="center">IsActive</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {productCategoryList.map((row) => (
                                                <TableRow key={row.specialProductCategoryCode}>
                                                    <TableCell align="center">
                                                        {row.specialProductCategoryCode}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.specialProductCategoryName}
                                                    </TableCell>
                                                    <TableCell align="center">{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="center">{<IconButton aria-label="delete"
                                                        onClick={(e) => handleClick(row)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                </Container>
            </Page>
        </>
    );
}